export default ({
  rootUrl,
  get,
}) => {
  const getAllMedatada = (refAddress) => {
    return get({
      url: rootUrl,
      endPoint: '/all.json',
      contentType: 'application/json',
    });
  }

  return {
    getAllMedatada,
  };
}
